import React from 'react';
import cx from 'classnames';
import { Props } from './SubPageTemplate.types';
import styles from './SubPageTemplate.module.scss';

const SubPageTemplate: React.FC<Props> = ({ title, children, isSticky, className }) => {
  return (
    <>
      <div className={cx({ [styles.titleBackground]: isSticky }, className)}>
        <h1 className={styles.title}>{title}</h1>
      </div>
      {children}
    </>
  );
};

export default SubPageTemplate;
